export default function CsharpWriteFiles() {
  return (
    <h2>Csharp Write Files</h2>
  );
}
